module.exports = __webpack_public_path__ + "media/images/weather/600_day-a7c595b572a4280e6f1a6cf0e6f46611.png";